import {
  DBTGithubConfigData,
  DBTQuerySelectionData,
  DBTCommitModelsData,
  DBTQuerySelectionKwargs,
  DBTCommitModelsKwargs,
} from "../../../types";

export const transformFieldsToDBTConfig = (
  fields: Record<string, any>
): DBTGithubConfigData => {
  return {
    github_dbt_folder_link: {
      type: fields.github_dbt_folder_link?.type || "string",
      required: fields.github_dbt_folder_link?.required || false,
      value: "",
      selected_data: fields.github_dbt_folder_link?.selected_data || null,
    },
    github_pat: {
      type: fields.github_pat?.type || "string",
      required: fields.github_pat?.required || false,
      value: "",
      selected_data: fields.github_pat?.selected_data || null,
    },
    data_limit: {
      type: fields.data_limit?.type || "integer",
      required: fields.data_limit?.required || false,
      value: 5,
      selected_data: fields.data_limit?.selected_data || null,
    },
  };
};

export const transformFieldsToQuerySelectionConfig = (
  fields: Record<string, any>,
  kwargs: DBTQuerySelectionKwargs
): DBTQuerySelectionData => {
  return {
    query_description: {
      type: fields.query_description?.type || "string",
      required: fields.query_description?.required || false,
      value: "",
      selected_data: fields.query_description?.selected_data || null,
    },
    invoke_dbt_agent: {
      type: fields.invoke_dbt_agent?.type || "boolean",
      required: fields.invoke_dbt_agent?.required || false,
      value: false,
      selected_data: fields.invoke_dbt_agent?.selected_data || null,
    },
    additional_kwargs: {
      dbt_sources: kwargs.dbt_sources || "",
    },
  };
};

export const transformFieldsToCommitModelsConfig = (
  fields: Record<string, any>,
  kwargs: DBTCommitModelsKwargs
): DBTCommitModelsData => {
  return {
    approval_status: {
      type: fields.approval_status?.type || "boolean",
      required: fields.approval_status?.required || false,
      value: false,
      selected_data: fields.approval_status?.selected_data || null,
    },
    convention_description: {
      type: fields.convention_description?.type || "string",
      required: fields.convention_description?.required || false,
      value: "",
      selected_data: fields.convention_description?.selected_data || null,
    },
    additional_kwargs: {
      sql: kwargs.sql || "",
      summary: kwargs.summary || "",
      resulted_transformation: kwargs.resulted_transformation || [],
    },
  };
};
